import { Button, Dialog } from '@noorden-insurtech/alba-design-system';
import { ClipboardList } from 'lucide-react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export function ModalProposalInAnalysis({ isOpen, onClose }: Props) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(details: { open: boolean }) => {
        if (!details.open) onClose();
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='max-w-md'>
          <Dialog.Header>
            <Dialog.Title className='flex items-center gap-2'>
              <ClipboardList
                className='w-5 h-5 text-alba-blue-500'
                strokeWidth={1.6}
              />
              Proposta em análise
            </Dialog.Title>
          </Dialog.Header>
          <Dialog.Body className='space-y-2'>
            <p className='text-alba-gray-700 text-sm leading-relaxed'>
              A proposta foi encaminhada para análise de subscrição.
            </p>
            <p className='text-alba-gray-700 text-sm leading-relaxed'>
              Você pode acompanhar o andamento na listagem de propostas.
            </p>
          </Dialog.Body>
          <Dialog.Footer>
            <Button variant='primary' size='md' onClick={onClose}>
              Entendi
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
